import { ChangeEvent, FC, useCallback, useState } from 'react'
import { Row, Col, Text, Breadcrumb, Image, Button, Input } from '@/client/components'
import * as S from './styles'
import { SearchResult } from '../SearchResult'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, header_section, result_section }) => {
  const [value, setValue] = useState('')
  const [isBoxOpen, setIsBoxOpen] = useState<boolean>(false)

  const handleChange = useCallback(
    (optionId, value) => {
      setValue(value)
    },
    [value]
  )

  const handleSubmitForm = useCallback(() => {
    value !== '' && setIsBoxOpen(true)
  }, [value, isBoxOpen])

  return (
    <S.Featured>
      <Row>
        <Col>
          <Breadcrumb pages={breadcrumb} />
        </Col>
      </Row>
      <Row>
        <Col>
          <S.MainFeatured>
            <S.Container>
              <Text size='xlg' weight='semiBlack' align='left' padding='0 0 0 1rem'>
                {header_section?.title}
              </Text>

              <S.SearchBox>
                <Text padding='1rem 0' color='weak'>
                  <span dangerouslySetInnerHTML={{ __html: header_section?.subtitle }} />
                </Text>
                <Input
                  isBlock
                  dimension='small'
                  className='search_input'
                  placeholder='P2301'
                  leftIcon='search'
                  type='text'
                  id='search_item'
                  name='search_item'
                  value={value}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    handleChange('search_item', event?.currentTarget?.value)
                  }}
                />
                <Button size='small' kind='dark' style={{ width: '100%' }} onClick={handleSubmitForm}>
                  {header_section.button_text}
                </Button>
                <Text padding='1rem 0' color='weak'>
                  {header_section.end_text}
                </Text>
              </S.SearchBox>
            </S.Container>

            <Image src={header_section.image.url} width='400' height='350' />
          </S.MainFeatured>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBoxOpen && (
            <SearchResult
              heading={result_section.heading}
              material_name={result_section.material_name}
              colour={result_section.colour}
              finishing={result_section.finishing}
              size={result_section.size}
              varnish={result_section.varnish}
              cutting={result_section.cutting}
              durable={result_section.durable}
              temperature={result_section.temperature}
              adhesive={result_section.adhesive}
              recycle={result_section.recycle}
              used={result_section.used}
              long_text={result_section.long_text}
              button_1={result_section.button_1}
              button_2={result_section.button_2}
            />
          )}
        </Col>
      </Row>
    </S.Featured>
  )
}
